import { Component, OnInit } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/auth.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { VersionService } from 'src/app/services/version.service';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss'],
})
export class VersionComponent implements OnInit {
  pVer: string = '';
  sVer: string = '';
  user: string | undefined = '';
  environment: string = '';

  unsubscribe$ = new Subject<void>();

  constructor(
    private version: VersionService,
    private auth: AuthService,
    private env: EnvironmentService
  ) {}

  ngOnInit(): void {
    if (this.auth.authToken) {
      this.user = this.auth.username;
    }

    this.environment = this.env.environment;

    forkJoin(this.version.getPortalVersion(), this.version.getServiceVersion())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((versions: string[]) => {
        this.pVer = versions[0];
        this.sVer = versions[1];
      });
  }
}
